<template>
  <b-container>
    <h1>Welcome to Teacher Institute Signup</h1>
    <div class="jumbotron">
      <b-pagination
        @input="paginate"
        v-model="page"
        :total-rows="totalRows"
        :per-page="perPage"
      ></b-pagination>

      <b-row
        class="mb-2 courselist"
        v-for="(course, index) in possibleCourses"
        :key="index"
      >
        <b-col class="text-right">
          <b-button
            class="btn-sm"
            sm="4"
            v-show="course.active == 'false'"
            variant="outline-primary"
            @click="activateCourse(index)"
          >
            <b-icon-plus></b-icon-plus>Activate
          </b-button>
          <b-button
            sm="4"
            v-show="course.active == 'true'"
            variant="outline-primary"
            class="btn-sm"
            @click="deactivateCourse(index)"
          >
            <b-icon-trash-fill></b-icon-trash-fill>Deactivate
          </b-button>
        </b-col>
        <b-col sm="8">
          <p class="align-middle">
            {{ course.title }}
            <b-badge variant="danger"
              >| ${{ course.cost }}
              <span class="sr-only">unread messages</span></b-badge
            >
          </p>
        </b-col>
      </b-row>

      <b-form @submit="search">
        <b-row class="mt-4">
          <b-col sm="3" class="text-right">
            <label :for="search">Search:</label>
          </b-col>
          <b-col sm="6">
            <b-form-input
              id="search"
              v-model="searchString"
              type="search"
            ></b-form-input>
          </b-col>
          <b-col sm="3">
            <b-button variant="outline-danger" type="submit">
              <b-icon-search></b-icon-search>Search
            </b-button>
          </b-col>
        </b-row>
      </b-form>

      <b-row class="mt-5 mb-5">
        <b-col sm="2"> </b-col>
        <b-col sm="8" class="text-center">
          <input
            type="checkbox"
            class="inline-block"
            id="checkbox-1"
            v-model="discountedCoursesActive"
            name="checkbox-1"
            true-value="true"
            false-value="false"
          />
          Discounted Courses Active<b
            v-b-tooltip.hover
            v-b-tooltip.html
            title="Use this toggle to enabled or disable Discounted Course Manager/Automation. This only activates the task to check if there are remaining discounts and if not to activate all deactivated courses and deactivate all activated course. It does not do the initial activation of the discounted courses"
            ><b-icon-info></b-icon-info
          ></b>
          <strong
            ><span
              v-if="
                discountedCoursesActive == true ||
                  discountedCoursesActive == 'true'
              "
              style="color: green !important;"
              >Enabled</span
            ><span
              v-if="
                discountedCoursesActive == false ||
                  discountedCoursesActive == 'false'
              "
              style="color: red !important;"
              >Disabled</span
            ></strong
          >
          <b-button v-on:click="saveDiscountedCoursesActive()">Save</b-button>
        </b-col>
        <b-col sm="2"> </b-col>
      </b-row>
      <b-row>
        <b-col sm="2"> </b-col>
        <b-col sm="2">
          <label class="mt-2">Discount Credit Limit: </label>
        </b-col>
        <b-col sm="4">
          <input
            type="text"
            class="form-control"
            v-model="discountCreditLimit"
          />
        </b-col>
        <b-col sm="3">
          <b-button
            class="btn btn-sm"
            variant="outline-danger"
            v-on:click="saveDiscountCreditLimit()"
            >Save Discount Credit Limit</b-button
          >
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col sm="2"> </b-col>
        <b-col sm="2">
          <label class="mt-2">Discount Credit Limit Warning: </label>
        </b-col>
        <b-col sm="4">
          <input
            type="text"
            class="form-control"
            v-model="discountCreditLimitWarning"
          />
        </b-col>
        <b-col sm="3">
          <b-button
            class="btn btn-sm"
            variant="outline-danger"
            v-on:click="saveDiscountCreditLimitWarning()"
            >Save Limit Warning</b-button
          >
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col sm="2"> </b-col>
        <b-col sm="2">
          <label class="mt-2">Admin Emails: </label>
        </b-col>
        <b-col sm="4">
          <input type="text" class="form-control" v-model="adminEmails" />
        </b-col>
        <b-col sm="3">
          <b-button
            class="btn btn-sm"
            variant="outline-danger"
            v-on:click="saveAdminEmails()"
            >Save Admin Emails</b-button
          >
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import { mixins } from "../mixins";

export default {
  name: "home",
  data() {
    return {
      page: 1,
      perPage: 8,
      totalRows: null,
      searchString: "",
      possibleCourses: null,
      discountCreditLimit: null,
      discountCreditLimitWarning: null,
      discountedCoursesActive: null,
      adminEmails: null,
    };
  },
  mixins: [mixins],
  created() {
    this.getCourses();
    this.getDiscountCreditLimit();
    this.getDiscountCreditLimitWarning();
    this.getDiscountedCoursesEnabled();
    this.getAdminEmails();
  },
  methods: {
    getDiscountedCoursesEnabled() {
      this.api
        .get("/discountedCoursesActive")
        .then((res) => {
          this.discountedCoursesActive = res.data;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.discountedCoursesActive = {
              title: "ERROR:",
            };
          } else {
            this.discountedCoursesActive = {
              title: "ERROR:",
            };
          }
        });
    },
    getDiscountCreditLimit() {
      this.api
        .get("/discountCreditLimit")
        .then((res) => {
          this.discountCreditLimit = res.data;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.discountCreditLimit = {
              title: "ERROR:",
            };
          } else {
            this.discountCreditLimit = {
              title: "ERROR:",
            };
          }
        });
    },
    getDiscountCreditLimitWarning() {
      this.api
        .get("/discountCreditLimitWarning")
        .then((res) => {
          this.discountCreditLimitWarning = res.data;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.discountCreditLimitWarning = {
              title: "ERROR:",
            };
          } else {
            this.discountCreditLimitWarning = {
              title: "ERROR:",
            };
          }
        });
    },
    getAdminEmails() {
      this.api
        .get("/adminEmails")
        .then((res) => {
          this.adminEmails = res.data;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.adminEmails = {
              title: "ERROR:",
            };
          } else {
            this.adminEmails = {
              title: "ERROR:",
            };
          }
        });
    },
    getCourses() {
      this.api
        .post("/secure/possibleCourses", {
          page: this.page,
          perPage: this.perPage,
          searchString: this.searchString,
        })
        .then((response) => {
          this.possibleCourses = response.data.courses;
          this.totalRows = response.data.totalRows;
        })
        .catch((error) => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
    saveDiscountCreditLimit() {
      this.api
        .post("/secure/setDiscountCreditLimit", {
          discountCreditLimit: this.discountCreditLimit,
        })
        .then((response) => {
          this.successToast(
            "The Discount Credit Limit has been saved!",
            response
          );
        })
        .catch((error) => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
    saveDiscountCreditLimitWarning() {
      this.api
        .post("/secure/setDiscountCreditLimitWarning", {
          discountCreditLimitWarning: this.discountCreditLimitWarning,
        })
        .then((response) => {
          this.successToast(
            "The Discount Credit Limit Warning has been saved!",
            response
          );
        })
        .catch((error) => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
    paginate(page) {
      this.page = page;
      this.getCourses();
    },
    search() {
      this.getCourses();
    },
    activateCourse(index) {
      let rec = this.possibleCourses[index];
      this.api
        .post("/secure/activateCourse", {
          term: rec.term,
          crn: rec.crn,
        })
        .then(() => {
          this.successToast("Course Activated");
          this.getCourses();
        })
        .catch((error) => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
    deactivateCourse(index) {
      let rec = this.possibleCourses[index];
      this.api
        .post("/secure/deactivateCourse", {
          term: rec.term,
          crn: rec.crn,
        })
        .then(() => {
          this.successToast("Course Deactivated");
          this.getCourses();
        })
        .catch((error) => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
    saveDiscountedCoursesActive() {
      this.api
        .post("secure/setDiscountedCoursesActive", {
          discountedCoursesActive: this.discountedCoursesActive,
        })
        .then((response) => {
          this.successToast(
            "Discounted Courses Active has been updated!",
            response
          );
        })
        .catch((error) => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
    saveAdminEmails() {
      this.api
        .post("secure/setAdminEmails", {
          adminEmails: this.adminEmails,
        })
        .then((response) => {
          this.successToast("Admin Email(s) update complete!", response);
        })
        .catch((error) => {
          this.errorToast(error.response.data.message || error.message || "");
        });
    },
  },
};
</script>

<style scoped>
.courselist:nth-child(even) {
  /* background: green !important; */
}
.courselist:nth-child(odd) {
  /* background: blue !important; */
}
</style>
